import { DeleteMedia } from './DeleteMedia'
import { CommonPropsMedia, MediaActionsTypes } from './types'

export const modalsActions: Record<
  MediaActionsTypes,
  React.FC<CommonPropsMedia>
> = {
  delete: DeleteMedia
}
